import React from "react";
import Styles from './styles.module.scss';
import { useTranslation } from "react-i18next";

const AcademyS1 = () => {
    const { t } = useTranslation();

    return (
        <section className={Styles.container}>
            <div className={Styles.absLine}/>
            <div className={`${Styles.contentWrap} ${Styles.pageContainer}`}>
                <div className={`${Styles.contentWrapTitle}`}><span>OMT {t('Академия')}</span></div>
                <div className={`${Styles.contentWrapSubTitle}`}>{t('Совершенствуй навыки,')}</div>
                <div className={`${Styles.contentWrapSubTitle}`}>{t('контролируй риски.')}</div>
                <div
                    className={`${Styles.aboutBtn}`}
                    role="button"
                    tabIndex={0}
                    onClick={() => window.open("https://honee.technology/academy", "_blank", "noopener,noreferrer")}
                >
                    {t('Записаться в Академию')}
                </div>
            </div>
        </section>
    );
};

export default AcademyS1;




